var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logo)?_c('div',{staticClass:"vcp-layer logo-layer"},[_c('div',{staticClass:"logo-wrap"},[_c('img',{attrs:{"alt":"logo","src":_vm.logo}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }